// extracted by mini-css-extract-plugin
export var attachmentContainer = "_gl-0";
export var fileList = "_gl-2";
export var removeFileButton = "_gl-1";